<template>
    <div class="card bg-diagonal bg-diagonal-light-primary border-0">
        <div class="card-body d-flex flex-lg-row">
            <div class="flex-grow-1 d-flex align-items-center justify-content-between px-4 flex-lg-wrap flex-xl-nowrap">
                <div class="d-flex flex-row align-items-center">
                    <i class="fas fa-house-user" style="font-size: 3.2em;"/>
                    <div class="d-flex flex-column ml-5">
                        Sie befinden sich in
                        <h2>{{ $page.props.agency.name }}</h2>
                    </div>
                </div>
            </div>
            <Center vertical>
                <div class="btn-group">
                    <a :href="$route('users.invitations.create')" class="btn btn-light-primary">
                        <i class="fas fa-user-plus" />
                        {{ __('navigation.invite_user') }}
                    </a>
                    <a :href="$route('users.invitations')" class="btn btn-light-primary">
                        <i class="fas fa-paper-plane" />
                        {{ __('navigation.invitations') }}
                    </a>
                </div>
            </Center>
        </div>
    </div>
</template>

<script>
import Center from '@components/Layout/Center.vue';

export default {
    components: {Center}
};
</script>
